import { createFileRoute } from "@tanstack/react-router";
import { ApiInternal } from "src/api/api_internal";
import Logs from "src/components/logs";

/**
 * The properties for {@link AdminLogs}
 */
export type AdminLogsProps = {};

/** The limit for the tablerows */
const LIMIT = 15;

/**
 * The settings for this site
 */
function AdminLogs(props: AdminLogsProps) {
    const { page } = Route.useSearch();
    const data = Route.useLoaderData();
    if (!data) {
        return;
    }

    return <Logs data={data} limit={LIMIT} currentPage={page} href={"/a/logs"} />;
}

/**
 * The search parameter for this view
 */
type LogSearchParams = {
    /** The currently active page number */
    page: number;
};

export const Route = createFileRoute("/_admin/a/logs/")({
    component: AdminLogs,
    validateSearch: (search: Record<string, unknown>): LogSearchParams => {
        const page = Number(search?.page ?? 1);
        return { page: page <= 0 ? 1 : page };
    },
    loaderDeps: ({ search: { page } }) => ({ page }),
    loader: async ({ deps: { page } }) =>
        await ApiInternal.changelog.get({
            limit: LIMIT,
            offset: (page - 1) * LIMIT,
        }),
});
